import API from "Services/Api";
import { createFilterParams } from "Utils/searchFilters";

interface GeneratePartner {
  name: string;
  login: string | null;
  appointments?: {
    id: number;
    name: string;
  }[];
  integration_codes?: {
    id: string;
    name: string;
  }[];
  categories?: number[];
  prod_include?: number[];
  prod_exclude?: number[];
}

interface PartnersParams {
  status: string;
  search: string;
  page: number;
}

type ProductPartner = {
  product: string;
  product_id: number;
  sku: string;
};
type PartnerDetails = Omit<
  GeneratePartner,
  "prod_include" | "prod_exclude" | "categories"
> & {
  id: number;
  auth_client_id: null | string;
  product_needs_authorization: boolean;
  free_visit: boolean;
  pre_flow: boolean;
  prod_include: ProductPartner[];
  prod_exclude: ProductPartner[];
  categories: {
    category: string;
    category_id: number;
  }[];
  path_logo: string;
  units: {
    exclude: number[];
    include: number[];
  };
};

export const getPartnersAPI = async (params: PartnersParams) => {
  const response = await API.get(`/clients`, {
    params: createFilterParams(params),
  });
  return response.data;
};

export const getAllPartnersAPI = async () => {
  const response = await API.get(`/clients/list`);
  return response.data;
};

export const getPartnerByIdAPI = async (
  partnerId: string
): Promise<PartnerDetails> => {
  const response = await API.get(`/clients/${partnerId}`);
  return response.data;
};

export const deletePartnersAPI = async (partnerId: number) => {
  const response = await API.delete(`/clients/${partnerId}`);
  return response.data;
};

export const updatePartnersAPI = async ({
  partner,
  partnerId,
}: {
  partnerId: number;
  partner: GeneratePartner;
}) => {
  const response = await API.put(`/clients/${partnerId}`, {
    ...partner,
  });
  return response.data;
};

export const createPartnersAPI = async (partner: GeneratePartner) => {
  const response = await API.post(`/clients`, {
    ...partner,
  });
  return response.data;
};

export const uploadLogoPartnerAPI = async (data: {
  partnerId: number;
  file: FormData;
}) => {
  const { partnerId, file: form } = data;

  const response = await API.post(`/clients/${partnerId}/upload`, form, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};
